<script lang="ts">
import type { HubSpotFormSchema } from '$lib/types/hubspot-form';
import HtmlText from '../../atoms/HtmlText/HtmlText.svelte';
import HubSpotForm from '../HubSpotForm/HubSpotForm.svelte';

interface Props {
    text?: string;
    formId: string;
    formSchema?: HubSpotFormSchema | null;
    portalId?: string;
    fieldLayout?: 'single-column' | 'double-column';
    showMailchimpCheckbox?: boolean;
    mailchimpCheckboxLabel?: string;
    successMessage?: string;
    submitButtonText?: string;
    conditionsText?: string;
    className?: string;
    replaceContainerOnSuccess?: boolean;
    successReplacementScope?: 'form' | 'block';
    blockSuccessMessage?: string;
    hideBlock?: boolean;
}

let {
    text = '',
    formId,
    formSchema = null,
    portalId = '',
    fieldLayout = 'double-column',
    showMailchimpCheckbox = false,
    mailchimpCheckboxLabel = 'Subscribe to our newsletter',
    successMessage = '<p>Thank you for your submission!</p>',
    submitButtonText = 'Submit',
    conditionsText = '',
    className = '',
    replaceContainerOnSuccess = false,
    successReplacementScope = 'form',
    blockSuccessMessage = '<p>Thank you for your submission!</p>',
    hideBlock = false,
}: Props = $props();

let submitted = $state(false);
let replaceBlockOnSuccess = $derived(
    successReplacementScope === 'block' || replaceContainerOnSuccess,
);
let resolvedBlockSuccessMessage = $derived(
    successReplacementScope === 'block' ? blockSuccessMessage : successMessage,
);

function handleSuccess() {
    if (replaceBlockOnSuccess) {
        submitted = true;
    }
}
</script>

{#if !hideBlock}
    {#if submitted && replaceBlockOnSuccess}
        <div class="content-and-form content-and-form--success">
            <HtmlText text={resolvedBlockSuccessMessage} />
        </div>
    {:else}
        <div class="content-and-form">
            <div class="content-and-form__col">
                <HtmlText {text} />
            </div>
            <div class="content-and-form__col">
                <HubSpotForm
                    {formId}
                    {formSchema}
                    {portalId}
                    {fieldLayout}
                    {showMailchimpCheckbox}
                    {mailchimpCheckboxLabel}
                    {successMessage}
                    {submitButtonText}
                    {conditionsText}
                    {className}
                    replaceContainerOnSuccess={false}
                    onSuccess={handleSuccess}
                />
            </div>
        </div>
    {/if}
{/if}

<style lang="scss">
    @use "sass-mq/mq" as *;

    .content-and-form {
        display: flex;
        flex-direction: column;
        gap: 4rem;
        padding: var(--layout-pagegrid-margin);

        @include mq($from: tablet) {
            flex-direction: row;
        }
    }

    .content-and-form__col {
        flex: 1;
    }
</style>
